import { render, staticRenderFns } from "./germplasmAnimal.vue?vue&type=template&id=345cb9f2&scoped=true&"
import script from "./germplasmAnimal.vue?vue&type=script&lang=js&"
export * from "./germplasmAnimal.vue?vue&type=script&lang=js&"
import style0 from "./germplasmAnimal.vue?vue&type=style&index=0&id=345cb9f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345cb9f2",
  null
  
)

export default component.exports